module.exports = __webpack_public_path__ + "static/img/bg.f781b40e.png";